// extracted by mini-css-extract-plugin
module.exports = {"container":"_1wr09ZSa7OR7IPMqb19lDP","banner":"_1tXUxDOKo-niZ9rB7oB-Jw","text":"_2xoqo3mtFWcH05cbjZ96jr","ingress":"_1hoJWLAGlk0JN2BQqUIt7a","cta":"_3tXkFpcyqbsr_bod4Jnp_o"};